import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Header from "../../layout/Header";
import LeftPanel from "../../layout/Leftpanel";
import instance from "../../../../WebApi/WebApi";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

const Esprovider = () => {
  const { t } = useTranslation();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [eanNumber, setEanNumber] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [providerList, setProviderList] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [fetchingInvoices, setFetchingInvoices] = useState([]);
  const [esServiceProvider, setEsServiceProvider] = useState("");
  // const [showEsProviderModal, setShowEsProviderModal] = useState(false);

  // Fetch the list of providers on page load
  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const response = await instance.get("/user/es-providers");
        setProviderList(response.data.data || []);
      } catch (error) {
        toast.error(t("Failed to fetch providers"));
      }
    };

    fetchProviders();
  }, []);

  const handleAddProvider = async () => {
    if (!esServiceProvider) {
      toast.error(t("Please select a service provider"));
      return;
    }

    if (esServiceProvider === "Advania" && eanNumber === "") {
      toast.error(t("EAN Number is required"));
      return;
    }

    if (!documentType) {
      toast.error(t("Please select a document type"));
      return;
    }

    if (!userName || !password) {
      toast.error(t("User ID and Password are required"));
      return;
    }

    if (!startDate) {
      toast.error(t("Please select Invoice Fetch Date"));
      return;
    }

    try {
      const response = await instance.post("/user/es-providers", {
        userName,
        password,
        startDate,
        documentType,
        serviceProvider: esServiceProvider,
        eanNumber,
      });

      if (response.data.success) {
        toast.success(t("Provider added successfully"));
        setUserName("");
        setPassword("");
        setStartDate(null);
        setFetchingInvoices([]);
        setProviderList((prev) => [...prev, response.data.data]);
      } else {
        toast.error(response.data.message || t("Failed to add provider"));
      }
    } catch (error) {
      toast.error(
        t(
          error?.response?.data?.message ||
            "An error occurred while adding the provider"
        )
      );
    } finally {
      // setShowEsProviderModal(false);
    }
  };

  const getInvoiceList = async (provider, index) => {
    if (!fetchingInvoices.includes(index)) {
      setFetchingInvoices((prev) => [...prev, index]);
    }

    // console.log(fetchingInvoices);

    // const invoiceUserName = provider.userName;
    // const invoiceServiceProvider = provider.serviceProvider;
    try {
      const response = await instance.get(
        `/user/es-providers/invoices?id=${provider.id}`
        // `/user/es-providers/invoices?id=${provider.id}&userName=${invoiceUserName}&serviceProvider=${invoiceServiceProvider}`
      );

      if (response.data.success) {
        toast.success(
          response.data.message || t("Invoice Sync Is In Progress!")
        );
        //  console.log(response.data.invoices);
      } else {
        //  console.log(response);
        toast.error(t("Failed to fetch Invoices"));
      }
    } catch (error) {
      // console.log(error);
      toast.error(error.response.data.message || "Failed to fetch Invoices");
    } finally {
      // setFetchingInvoices((prev) => prev.filter((i) => i !== index));
    }
  };

  // Function to open EsProviderModal
  // const openEsProviderModal = () => setShowEsProviderModal(true);

  // Function to close EsProviderModal
  // const closeEsProviderModal = () => setShowEsProviderModal(false);

  return (
    <div className="container-fluid">
      <div className="dbMain esprovide">
        <LeftPanel breadcm={t("eis_company")} />
        <div className="dbRight">
          <Header link="/dashboard" title={t("eis_company")} description="" />
          <div className="commonBase mb-4">
            <div className="dbtableTop">
              <div className="dbSearch">
                <h6>{t("eis_connections")}</h6>
              </div>
              <div className="dbtableSrchbg">
                <button
                  className="commonButton"
                  data-bs-toggle="modal"
                  // onClick={() => openEsProviderModal()}
                  data-bs-target="#esprovideModal"
                  disabled={fetchingInvoices.length > 0} // Disable button if sync is in progress
                  style={{
                    pointerEvents:
                      fetchingInvoices.length > 0 ? "none" : "auto",
                    opacity: fetchingInvoices.length > 0 ? 0.5 : 1,
                    cursor:
                      fetchingInvoices.length > 0 ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-plus"></i>{" "}
                  {t("add") + " " + t("eis_connection")}
                </button>
              </div>
            </div>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("EIS Provider")}</th>
                    <th>{t("User Id")}</th>
                    <th>{t("Sync From")}</th>
                    <th>{t("Sync Upto")}</th>
                    <th>{t("Action")}</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {providerList && providerList.length > 0 ? (
                    providerList.map((provider, index) => (
                      <tr key={index}>
                        <td data-label={t("eis_company_name")}>
                          {provider?.serviceProvider}
                        </td>
                        <td data-label={t("identification_number")}>
                          {provider?.userName}
                        </td>
                        <td
                          data-label={t("fetch_from")}
                          title="Invoices will be fetched from (DD-MM-YYYY HH:mm:ss)"
                        >
                          {moment(provider?.fetchFrom).format("DD-MM-YYYY")}
                          <br />
                          {"00:00:00 AM"}
                        </td>
                        <td
                          data-label={t("fetch_from")}
                          title="Invoices will be fetched from (DD-MM-YYYY HH:mm:ss)"
                        >
                          {provider?.fetchTo ? (
                            <>
                              <div>
                                {moment(provider.fetchTo).format("DD-MM-YYYY")}
                              </div>
                              <div>
                                {moment(provider.fetchTo).format("HH:mm:ss A")}
                              </div>
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td data-label={t("action")}>
                          {fetchingInvoices.includes(index) ||
                          provider.syncCompleted == false ? (
                            <i
                              title="Invoice sync is in progress"
                              className="fs-6 ms-2 fa-solid fa-rotate text-success fa-spin"
                            ></i>
                          ) : provider.syncCompleted == true ? (
                            <i
                              title="Invoice sync completed"
                              className="fs-6 ms-2 fa-solid fa-rotate text-success"
                            ></i>
                          ) : (
                            <Link
                              to=""
                              title="Fetch Invoices"
                              onClick={(e) => {
                                e.preventDefault();
                                getInvoiceList(provider, index);
                              }}
                              style={{
                                pointerEvents:
                                  fetchingInvoices.length > 0 ? "none" : "auto",
                                opacity: fetchingInvoices.length > 0 ? 0.5 : 1,
                                cursor:
                                  fetchingInvoices.length > 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            >
                              <i className="fs-6 ms-2 fa-solid fa-rotate"></i>
                            </Link>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        {t("No Connections Found")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Modal */}
          {/* {showEsProviderModal && ( */}
            <div
              className="modal fade"
              id="esprovideModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      {t("add_es_provider")}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3 row">
                      <label
                        htmlFor="staticEmail"
                        className="col-sm-4 col-form-label"
                      >
                        {t("select_es_provider")}
                      </label>
                      <div className="col-sm-8">
                        <select
                          className="form-control"
                          value={esServiceProvider}
                          onChange={(e) => setEsServiceProvider(e.target.value)}
                        >
                          <option value="" disabled selected>
                            {t("Select ES Provider")}
                          </option>
                          <option value="Advania">{t("Advania")}</option>
                          <option value="Unimaze">{t("Unimaze")}</option>
                        </select>
                      </div>
                    </div>
                    {esServiceProvider && esServiceProvider === "Advania" && (
                      <div>
                        <div className="mb-3 row">
                          <label className="col-sm-4 col-form-label">
                            {t("EAN Number")}
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="EAN Number of the company"
                              value={eanNumber}
                              onChange={(e) => setEanNumber(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="mb-3 row">
                      <label
                        htmlFor="staticEmail"
                        className="col-sm-4 col-form-label"
                      >
                        {"Select Document"}
                      </label>
                      <div className="col-sm-8">
                        <select
                          className="form-control"
                          value={documentType}
                          onChange={(e) => setDocumentType(e.target.value)}
                        >
                          <option value="" disabled>
                            {t("Select Document")}
                          </option>
                          <option value="Invoice" selected>
                            {"Invoice"}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label
                        htmlFor="staticEmail"
                        className="col-sm-4 col-form-label"
                      >
                        {"Fetch Invoice From"}
                      </label>
                      <div className="col-sm-8">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="dd/MM/yyyy"
                          className="form-control w-full"
                          placeholderText={t("Select Date")}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="mb-3 row">
                        <label className="col-sm-4 col-form-label">
                          {t("User Id")}
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Username of ES Provider account"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-sm-4 col-form-label">
                          {t("Password")}
                        </label>
                        <div className="col-sm-8">
                          <input
                            type={showPassword ? "text" : "password"} // Toggle between text and password
                            className="form-control"
                            placeholder="Password of ES Provider account"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <input
                            id="showPassword"
                            type="checkbox"
                            checked={showPassword}
                            onChange={() => setShowPassword(!showPassword)} // Toggle the state
                          />{" "}
                          <label className="pointer" for="showPassword">
                            {t("Show Password")}
                          </label>
                          {/* <input
                          type="password"
                          className="form-control"
                          placeholder="Password of unimaze account"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <input type="checkbox" />{" "}
                        <span className="ps-2">{t("Show Password")}</span> */}
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          type="button"
                          className="commonButton"
                          onClick={handleAddProvider}
                        >
                          {t("add")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default Esprovider;
